import cn from 'classnames';
import { ButtonHTMLAttributes, FC, MouseEventHandler, ReactNode } from 'react';

import { Icon, IconNames } from '@/shared/ui';

import styles from './EditorButton.module.scss';

type EditorButtonVariant = 'hairline' | 'outlineViolet' | 'icon';

type EditorButtonProps = {
  variant: EditorButtonVariant;
  children?: ReactNode;
  className?: string;
  icon?: IconNames;
  title?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
} & Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-label' | 'aria-expanded'
>;

const VARIANT_CLASS_NAMES: Record<EditorButtonVariant, string> = {
  hairline: styles.hairline,
  outlineViolet: styles.outlineViolet,
  icon: styles.icon,
};

export const EditorButton: FC<EditorButtonProps> = (props) => {
  const {
    variant,
    children,
    className,
    icon,
    title,
    disabled,
    onClick,
    'aria-label': ariaLabel,
    'aria-expanded': ariaExpanded,
  } = props;

  const leadingIconSize = variant === 'outlineViolet' ? 15 : 16;

  return (
    <button
      type="button"
      className={cn(styles.button, VARIANT_CLASS_NAMES[variant], className)}
      title={title}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      onClick={onClick}
    >
      {icon && variant !== 'icon' && (
        <Icon name={icon} size={leadingIconSize} />
      )}
      {children}
    </button>
  );
};
